import { defaultPm2PrintChunkClassName } from '@provider/print';
import { jsx } from 'react/jsx-runtime';
import { Scrambled } from './molecules/embed-iframe/atom.scrambled.js';

const printIframeComponentPaper = () => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsx(Scrambled, {})
  }];
};
const printIframeComponentFrameworkPaper = () => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsx(Scrambled, {})
  }];
};
const iframeComponentPaperPrinters = {
  "iframe-component": printIframeComponentPaper,
  "iframe-component.component-framework": printIframeComponentFrameworkPaper
};

export { iframeComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
